import * as React from "react";
import styled from "styled-components";
import CloseButtonComponent from "./CloseButton";
import { select, useSelect } from "@hubper/theme";
import posed from "react-pose";
import { Text } from "..";

const Base = posed(styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${select.color(["grey", 0])};
  border-radius: 5px;
`)({
  enter: {
    opacity: 1,
    scale: 1,
    transition: { type: "spring", stiffness: 300, damping: 30, velocity: 0 }
  },
  exit: {
    opacity: 0,
    scale: 0.8,
    height: 0,
    transition: { type: "spring", stiffness: 300, damping: 30, velocity: 0 }
  }
});

const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${select.space(4)};
`;

const CloseButton = styled(CloseButtonComponent)`
  position: absolute;
  right: 0;
  top: 0;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  title: string;
  description?: string;
  children?: any;
  defaultClosed?: boolean;
  left?: React.ReactNode;
  right?: React.ReactNode;
  beforeTitle?: React.ReactNode;
  afterTitle?: React.ReactNode;
};

function HelpTile(
  {
    style,
    className,
    title,
    description,
    defaultClosed,
    left,
    right,
    beforeTitle,
    afterTitle,
    children
  }: Props,
  ref: any
) {
  const select = useSelect();
  const [open, setOpen] = React.useState(!defaultClosed);
  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      pose={open ? "enter" : "exit"}
    >
      <CloseButton text="sluiten" onClick={() => setOpen(false)} />
      {left}
      <Main>
        <Text
          fw="heavy"
          fs={2}
          style={{
            alignSelf: "center",
            textAlign: "center",
            marginBottom: select.space(0)
          }}
        >
          {beforeTitle}
          {title}
          {afterTitle}
        </Text>
        {description && (
          <Text
            fs={-1}
            style={{ alignSelf: "center", textAlign: "center", maxWidth: 420 }}
          >
            {description}
          </Text>
        )}
        {children}
      </Main>
      {right}
    </Base>
  );
}

export default React.forwardRef(HelpTile);
